import Link from 'next/link'

export function FreemagicFormPrivacy() {
  return (
    <>
      <hr className="my-4 border-0 border-t border-black/10" />
      <p className="mb-0 text-sm leading-normal text-[#6c757d] [&_a]:text-[#6c757d] [&_a]:underline hover:[&_a]:text-[#565e64]">
        By submitting this form you agree to our{' '}
        <Link href="/faqs/privacy/">privacy policy</Link>.
      </p>
    </>
  )
}
